import { render, staticRenderFns } from "./AppointmentTotal.vue?vue&type=template&id=51203ede"
import script from "./AppointmentTotal.vue?vue&type=script&lang=js"
export * from "./AppointmentTotal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports